

const formDetails = {
    form: {
        name: 'SATISFACTION',
        version: '1.0',
        title: "We'd love your feedback!",
    },
    questions: [
        {
            // required fields
            questionText: 'How happy are you with Waved?',
            questionId: 'SATISFACTION_STAR',
            questionNumber: 1,
            answerValueType: 'number',

            // optional fields
            answerMinValue: 1,
            answerMaxValue: 5,

        },
        {
            // required fields
            questionText: "What's working well?",
            questionSubtext: "Select all that apply",
            questionId: 'SATISFACTION_LIKE',
            questionNumber: 2,
            answerValueType: 'text',

            // optional fields for rendering
            pillOptions: [
                'Brand consistency',
                "Intuitive interface",
                "Saves time",
                "Less noise complaints",
                "Great support",
                "Just works",
                "Perfect atmosphere",
                "Ease of mind",
                'Other',
            ]
        },
        {
            // required fields
            questionText: 'What could we improve?',
            questionId: 'SATISFACTION_IMPROVE',
            questionNumber: 3,
            answerValueType: 'text',

        },
        {
            // required fields
            questionText: 'Know someone who’d love Waved?',
            questionSubtext: 'Refer them for a chance to win a reward!',
            questionId: 'SATISFACTION_RECOMMEND',
            questionNumber: 4,
            answerValueType: 'text',

        },
        {
            // required fields
            questionText: "Thank's for your feedback!",
            questionSubtext: "We'll reach out ASAP!",
            questionId: 'SATISFACTION_ELABORATE',
            questionNumber: 5,
            answerValueType: 'text',

        }
    ]
}

export {
    formDetails,
}